import { useSyncExternalStore } from "react";

const subscribe = (onStoreChange: () => void) => {
  if (typeof window === "undefined") {
    return () => {};
  }
  const m = window.matchMedia("(max-width: 767px)");
  m.addEventListener("change", onStoreChange);
  return () => m.removeEventListener("change", onStoreChange);
};

const getSnapshotNarrow = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia("(max-width: 767px)").matches;
};

const getServerSnapshot = () => false;

/**
 * True on viewports at or below 767px (Tailwind: below `md` / 768px).
 */
export function useIsNarrowViewport(): boolean {
  return useSyncExternalStore(subscribe, getSnapshotNarrow, getServerSnapshot);
}
